import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { http } from '@/http'
import '@/plugins/vuelidate'
import './assets/scss/main.scss'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import VueSweetAlert from 'vue-sweetalert2'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(Chartkick.use(Chart))
Vue.use(VueSweetAlert)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  http,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
